module.exports = __webpack_public_path__ + "img/famous_p8.5be723b9.png";